<template>
  <v-container class="text-center">
    <h2>Not Found</h2>
    <p>Where do you think you're going?</p>
    <div class="v-flex">
      <v-btn color="primary" @click="redirect">Go home?</v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  methods: {
    redirect () {
      this.$router.replace({ name: 'Home' })
    }
  }
}
</script>
